import React from 'react';

import Meta from "../views/Meta"
import Events from "../views/Events"
import Deliveries from "../views/Deliveries"
import Analytics from "../views/Analytics"
import Queue from "../views/Queue"
import Users from "../views/Users"
import Report from "../views/Report";
import Aggregate from "../views/Aggregate";

import PeopleIcon from '@material-ui/icons/People';
import VehicleIcon from '@material-ui/icons/DriveEta';
import ReportIcon from '@material-ui/icons/EventNote';
import AnalyticsIcon from '@material-ui/icons/BarChart';
import DeliveryIcon from '@material-ui/icons/LocalShipping';
import NotificationIcon from '@material-ui/icons/Notifications';
import QueueIcon from '@material-ui/icons/DepartureBoard';
import FunctionsIcon from '@material-ui/icons/Functions';

const Routes = [
  {
    path: "/admin/users",
    name: "Usuários",
    icon: <PeopleIcon/>,
    component: Users
  },
  {
    path: "/admin/vehicles",
    name: "Veículos",
    icon: <VehicleIcon/>,
    component: Meta
  },
  {
    path: "/admin/deliveries",
    name: "Pré Cargas",
    icon: <DeliveryIcon/>,
    component: Deliveries
  },
  {
    path: "/admin/queue",
    name: "Fila de Espera",
    icon: <QueueIcon/>,
    component: Queue
  },
  {
    path: "/admin/report",
    name: "Relatório",
    icon: <ReportIcon/>,
    component: Report
  },
  {
    path: "/admin/aggregate",
    name: "Agregados",
    icon: <FunctionsIcon/>,
    component: Aggregate
  },
  {
    path: "/admin/analytics",
    name: "Análise",
    icon: <AnalyticsIcon/>,
    component: Analytics
  },
  {
    path: "/admin/events",
    name: "Eventos",
    icon: <NotificationIcon/>,
    component: Events
  },
];

export default Routes;
